import { Sucursal } from './sucursal.service'

import { http } from '@/app/lib/http/client'

export interface CashRegisterItem {
  id: number
  company_id: number
  sucursal_id: number
  name: string
  code: string
  cash_limit_amount: string
  is_active: boolean
  sucursal?: Pick<Sucursal, 'id' | 'name'>
  created_at?: string
  updated_at?: string
}

export interface CreateCashRegisterPayload {
  sucursal_id: number
  name: string
  code: string
  cash_limit_amount: number
  is_active?: boolean
}

export interface UpdateCashRegisterPayload {
  sucursal_id?: number
  name?: string
  code?: string
  cash_limit_amount?: number
  is_active?: boolean
}

export const cashRegisterService = {
  // Obtener todas
  async getItems(params?: { per_page?: number; search?: string; page?: number; all?: boolean; sucursal_id?: number }) {
    const response = await http.get('/cash-registers', { params })
    return response.data
  },

  async getItem(id: number) {
    const response = await http.get(`/cash-registers/${id}`)
    return response.data
  },

  // Crear
  async createItem(payload: CreateCashRegisterPayload) {
    const response = await http.post('/cash-registers', payload)
    return response.data
  },

  // Actualizar
  async updateItem(id: number, payload: UpdateCashRegisterPayload) {
    const response = await http.put(`/cash-registers/${id}`, payload)
    return response.data
  },

  // Cambiar estado activo/inactivo (PATCH)
  async toggleStatus(id: number) {
    const response = await http.patch(`/cash-registers/${id}/status`)
    return response.data
  },
}
